module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution1_1-24c9808d693ca30b25837927a0d817a4.png";